import React from 'react'
import MenuItem from '@material-ui/core/MenuItem';

import { SelectInput } from '../Inputs'

const choices = [
    {
        "name": "Validado",
        "value": "1"
    },
    {
        "name": "Rechazado",
        "value": "2"
    },
    {
        "name": "En Uso",
        "value": "3"
    },
    {
        "name": "No Validado",
        "value": "0"
    }
]

export const ValidadoSelectInput = (props) => (
    <SelectInput {...props}>
        {choices.map(choice => (
            <MenuItem key={choice.value} value={choice.value}>{choice.name}</MenuItem>
        ))}
    </SelectInput>
)
